import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber'

import { convertCountryCode3to2 } from './i18n'
const phoneUtil = PhoneNumberUtil.getInstance()
const enum PhoneNumberType {
  MOBILE = 1,
  FIXED_LINE_OR_MOBILE = 2
}

export const getCountryCallingCode = (countryCode: string): string => {
  if (countryCode.length === 3) {
    countryCode = convertCountryCode3to2(countryCode)
  }
  try {
    return phoneUtil.getCountryCodeForRegion(countryCode).toString()
  } catch {
    return ''
  }
}

export const getCountryCode = (countryCallingCode: string): string => {
  try {
    return phoneUtil.getRegionCodeForCountryCode(parseInt(countryCallingCode)).toString()
  } catch {
    return ''
  }
}

export const isValidPhoneNumber = (countryCode: string, phoneNumber: string): boolean => {
  const supportedRegions = phoneUtil.getSupportedRegions()
  if (!countryCode) {
    return supportedRegions.some((country: string) => isValidPhoneNumberForCountry(country, phoneNumber))
  }
  if (countryCode.length === 3) {
    try {
      countryCode = convertCountryCode3to2(countryCode)
    } catch {
      return false
    }
  }
  if (countryCode.length !== 2) {
    return false
  }
  if (!supportedRegions.includes(countryCode.toUpperCase())) {
    return true
  }
  return isValidPhoneNumberForCountry(countryCode, phoneNumber)
}
const isValidPhoneNumberForCountry = (countryCode: string, phoneNumber: string) => {
  let parsedPhoneNumber
  try {
    parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode)
  } catch (error) {
    return false
  }
  try {
    return (
      phoneUtil.isValidNumber(parsedPhoneNumber) &&
      (phoneUtil.getNumberType(parsedPhoneNumber) === PhoneNumberType.MOBILE ||
        phoneUtil.getNumberType(parsedPhoneNumber) === PhoneNumberType.FIXED_LINE_OR_MOBILE)
    )
  } catch (error) {
    return false
  }
}

export const getInternationalPhoneNumberWithCCC = (phoneNumber: string): string => {
  try {
    if (phoneNumber.startsWith('+')) {
      phoneNumber = phoneNumber.substring(1)
    }
    return phoneUtil.format(phoneUtil.parse('+' + phoneNumber, null), PhoneNumberFormat.INTERNATIONAL)
  } catch {
    return ''
  }
}

export const getInternationalPhoneNumber = (countryCode: string, phoneNumber: string): string => {
  if (countryCode.length === 3) {
    countryCode = convertCountryCode3to2(countryCode)
  }
  return phoneUtil.format(phoneUtil.parse(phoneNumber, countryCode), PhoneNumberFormat.INTERNATIONAL)
}

export const getNationalPhoneNumber = (countryCode: string, phoneNumber: string): string => {
  if (countryCode.length === 3) {
    countryCode = convertCountryCode3to2(countryCode)
  }
  return phoneUtil.format(phoneUtil.parse(phoneNumber, countryCode), PhoneNumberFormat.NATIONAL)
}
export const getE164PhoneNumber = (countryCode: string, phoneNumber: string): string => {
  if (countryCode.length === 3) {
    countryCode = convertCountryCode3to2(countryCode)
  }
  return phoneUtil.format(phoneUtil.parse(phoneNumber, countryCode), PhoneNumberFormat.E164)
}
